import { createFileRoute, redirect } from '@tanstack/react-router';

/** Legacy `/admin/users/$userId/settings` → `/users/$userId` */
export const Route = createFileRoute(
  '/_private/_route/_internal/admin/users/$userId/settings/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      params: { userId: params.userId },
      replace: true,
      to: '/users/$userId',
    });
  },
});
